import React from 'react';
import { Dropdown } from "semantic-ui-react";
import { I18n } from 'react-i18next';
import moment from 'moment'


const languageOptions = [
  { key: 'fr', text: 'FR', value: 'fr' },
  { key: 'en', text: 'EN', value: 'en' },
  { key: 'es', text: 'ES', value: 'es' },
  { key: 'it', text: 'IT', value: 'it' },
  { key: 'pt', text: 'PT', value: 'pt' },
]


const LanguageSwitch = () => (
  <I18n ns="translations">
    {
      (t, { i18n }) => (
        <Dropdown
          id="language-dropdown"
          selection
          value={i18n.language.substr(0,2)}
          options={languageOptions}
          onChange={(e, data) => {
            i18n.changeLanguage(data.value)
            moment.locale(data.value)
          }}
          // text='Select Language'
        />
      )
    }
  </I18n>
)

export default LanguageSwitch;



// WEBPACK FOOTER //
// ./src/components/LanguageSwitch.js